export default "__VITE_ASSET__61594db1__"